export type ResultsMetadata<T> = {
  data: {
    ids: Set<string>;
    data: T[];
  };
  areAllResultsLoaded: boolean;
  loadableImagesCount: number;
};

/**
 * Processes new paginated results to be used for infinite scroll
 */
export const processImageResults = <T extends { id: string; image?: any }>(
  previousState: ResultsMetadata<T>,
  currentQueryResult?: {
    data: T[];
    pagination?: { hasNextPage: boolean };
  }
): ResultsMetadata<T> => {
  if (!currentQueryResult || !currentQueryResult.pagination) {
    return previousState;
  }
  const nextData = {
    ids: new Set(previousState.data.ids),
    data: [...previousState.data.data],
  };
  for (const result of currentQueryResult.data) {
    const { id } = result;
    if (!previousState.data.ids.has(id)) {
      nextData.ids.add(id);
      nextData.data.push(result);
    }
  }

  return {
    data: nextData,
    areAllResultsLoaded: !currentQueryResult.pagination.hasNextPage,
    loadableImagesCount: nextData.data.filter(({ image }) => image).length,
  };
};
